import React from "react";
import styled from "styled-components";
import { lightGreyOutline } from "../../../styles";
import { boxShadow } from "../styledComponents";
import { Icon, IconContainer } from "../../visuals/styledComponents";

const TitleIconContainer = styled(IconContainer)<{ $iconSize: number }>`
  border: 1px solid ${lightGreyOutline};
  box-shadow: ${boxShadow};

  img {
    width: ${({ $iconSize }): number => $iconSize}px;
    height: ${({ $iconSize }): number => $iconSize}px;
    object-fit: contain;
  }
`;

export interface ModalTitleIconProps {
  /** Icon source */
  src: string;
  /** Alt text for accessibility */
  alt?: string;
  /** Size of the container (default: 42) */
  size?: number;
  /** Size of the icon image inside (default: 24) */
  iconSize?: number;
  /** Border radius percentage (default: 14) */
  borderRadius?: number;
  /** Padding (default: 9) */
  padding?: number;
}

export const ModalTitleIcon: React.FC<ModalTitleIconProps> = ({
  src,
  alt = "",
  size = 42,
  iconSize = 24,
  borderRadius = 14,
  padding = 9,
}) => {
  return (
    <TitleIconContainer
      size={size}
      br={borderRadius}
      p={padding}
      $iconSize={iconSize}
    >
      <Icon src={src} alt={alt} />
    </TitleIconContainer>
  );
};
